// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.VerifyLandlordIdentityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity } from '@zg-rentals/ts-rent-payment-client';

import type { VerifyLandlordIdentityWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Args {
  postData: VerifyLandlordIdentityWebApiRequestDto;
}

export type VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Options = UseMutationOptions<
  void,
  unknown,
  VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Args
>;

/**
 * Verify landlord identity
 */
export const useVerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity = ({
  httpClient,
  ...options
}: Omit<VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Args) =>
      VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity(args.postData, httpClient),
  });
};
